module.exports = __webpack_public_path__ + "img/diamond_banner_fantan.3f595e5d.png";